import { useAiSettings, useRbacPrimaryRolePermissions } from "../../../api/hooks";

/**
 * Whether form creation is offered to this user: the company AI setting AND the permission the
 * backend's checkFormPermission tool gates on. Single source of truth for the trigger's visibility
 * term and the panel's Forms quick-action card, which would otherwise disagree about the permission.
 */
export const useFormQuickActionEnabled = (): boolean => {
	const { data: aiSettings } = useAiSettings();
	const { data: reviewPermissions } = useRbacPrimaryRolePermissions("review");

	const formCreationEnabled = aiSettings?.conversationalAiSettings?.formCreationEnabled ?? false;
	const canCreateForms = reviewPermissions?.includes("reviews:createAdminCompanyForms") ?? false;

	return formCreationEnabled && canCreateForms;
};
